import Swal from 'sweetalert2';

// Setup global focus handler to prevent aria-hidden on focused elements
if (typeof window !== 'undefined') {
  document.addEventListener('focus', (event) => {
    let element = event.target;
    // Remove aria-hidden from focused element and all parents up to body
    while (element && element !== document.body) {
      if (element.hasAttribute('aria-hidden')) {
        element.removeAttribute('aria-hidden');
      }
      element = element.parentElement;
    }
  }, true); // Use capture phase to catch all focus events
}

// Wrapper around Swal.fire that removes focus and aria-hidden issues
const SwalWithA11yFix = async (options) => {
  return Swal.fire({
    ...options,
    // Set z-index higher than Material-UI dialogs (1300) to appear on top
    customClass: {
      container: 'swal2-container-high-z',
    },
    didOpen: (modal) => {
      if (modal) {
        // Set high z-index to appear above Material-UI dialogs (1300)
        const swalContainer = document.querySelector('.swal2-container');
        if (swalContainer) {
          swalContainer.style.zIndex = '1400';
        }
        
        // Set backdrop z-index with a small delay to ensure it's created
        setTimeout(() => {
          const swalBackdrop = document.querySelector('.swal2-backdrop-show');
          if (swalBackdrop) {
            swalBackdrop.style.zIndex = '1399';
          }
        }, 10);
        
        // Remove aria-hidden from modal and all parent elements
        modal.removeAttribute('aria-hidden');
        let parent = modal.parentElement;
        while (parent) {
          parent.removeAttribute('aria-hidden');
          parent = parent.parentElement;
        }
        
        // Blur any focused elements to remove focus
        if (document.activeElement && document.activeElement !== document.body) {
          document.activeElement.blur();
        }
      }
      
      // Call user's didOpen callback if provided
      if (options.didOpen && typeof options.didOpen === 'function') {
        options.didOpen(modal);
      }
    },
  });
};

export default SwalWithA11yFix;
